<div class="container">
  <h1 i18n>Política de Cambios y Cancelaciones de Consultas</h1>
  <div class="dakkini-card mt-4">
    <p class="m-0 fs-14px" i18n>
      A través de este documento, se establecen las condiciones bajo las cuales los usuarios pueden realizar cambios o
      cancelaciones de las consultas programadas. Al acceder o utilizar nuestros servicios, usted acepta y está de
      acuerdo con los términos establecidos en esta Política de Cancelación y Modificación.
    </p>
    <p class="m-0 mt-4 fs-14px" i18n>
      <strong>1. Cambios y Cancelaciones de Consultas</strong>
    </p>
    <p class="m-0 fs-14px" i18n>
      1.1. Plazo para Cancelación o Modificación</p>
    <p class="m-0 fs-14px" i18n>
      Los usuarios podrán cancelar o modificar una consulta programada con al menos 2 horas de anticipación a la hora
      acordada para la consulta.
    </p>
    <p class="m-0 fs-14px" i18n>
      1.2. Condiciones para la Cancelación o Modificación</p>
    <p class="m-0 fs-14px" i18n>
      Las cancelaciones o modificaciones que se realicen fuera del plazo de 2 horas antes de la consulta no serán
      consideradas válidas y, en consecuencia, no se otorgará reembolso alguno.
    </p>
    <p class="m-0 mt-4 fs-14px" i18n>
      <strong>2. No Reembolsos por Cancelaciones Tardías</strong>
    </p>
    <p class="m-0 fs-14px" i18n>
      2.1. Política de No Reembolsos</p>
    <p class="m-0 fs-14px" i18n>
      Si el usuario no cancela o modifica su consulta con el tiempo mínimo de 2 horas de anticipación, el pago realizado
      será considerado como definitivo y no se otorgará ningún reembolso por el servicio.
    </p>
    <p class="m-0 mt-4 fs-14px" i18n>
      <strong>3 Procedimiento para Cancelar o Modificar Consultas</strong>
    </p>
    <p class="m-0 fs-14px" i18n>
      3.1. Método de Cancelación o Modificación</p>
    <p class="m-0 fs-14px" i18n>
      Para realizar una cancelación o modificación, el usuario debe seguir el procedimiento establecido a través del
      sistema de reservas en línea o ponerse en contacto con el equipo de soporte mediante los canales habilitados en
      nuestra plataforma.
    </p>
    <p class="m-0 fs-14px" i18n>
      3.2. Confirmación de Cancelación</p>
    <p class="m-0 fs-14px" i18n>
      Una vez procesada la solicitud de cancelación o modificación, el usuario recibirá una confirmación por correo
      electrónico o mediante el sistema, indicando que la consulta ha sido correctamente modificada o cancelada.
    </p>
    <p class="m-0 mt-4 fs-14px" i18n>
      <strong>4. Responsabilidad del Usuario</strong>
    </p>
    <p class="m-0 fs-14px" i18n>
      4.1. Cumplimiento de la Política</p>
    <p class="m-0 fs-14px" i18n>
      El usuario es responsable de realizar la cancelación o modificación de la consulta dentro del plazo indicado.
      Asimismo, es responsable de verificar que dicha cancelación haya sido registrada correctamente en el sistema.
    </p>
    <p class="m-0 fs-14px" i18n>
      4.2. Registro de Solicitudes</p>
    <p class="m-0 fs-14px" i18n>
      Es responsabilidad del usuario asegurarse de que su solicitud de cancelación o modificación haya sido confirmada.
      La empresa no se hace responsable por solicitudes no procesadas o no confirmadas.
    </p>
    <p class="m-0 mt-4 fs-14px" i18n>
      <strong>Última modificación:</strong> 03 de enero de 2023
    </p>
  </div>
</div>